import { FC } from 'react'

import { DateTime } from 'components/UI'
import { getAttendanceReasonName } from 'services/Utilities'
import { t } from 'translations'

type Props = {
  attendance: MData.Attendance
}

const AttendanceItem: FC<Props> = ({ attendance }) => {
  if (!attendance) return null

  const requestTypeText =
    attendance.requestTypeId === 1 ? 'ABSENCE' : attendance.requestTypeId === 2 ? 'ARRIVING' : attendance.requestTypeId === 3 ? 'LEAVING' : null

  const getDate = () => {
    // Datetime is specific
    if (attendance.start && attendance.end) {
      return (
        <span>
          <DateTime date={attendance.start} outFormat="humanDateFull" /> <DateTime date={[attendance.start, attendance.end]} outFormat="time" range />
        </span>
      )
    }
    // Is all day
    return <DateTime date={attendance.start} />
  }
  return (
    <>
      {attendance.requestTypeId ? <b>{t(`employee.requestType.${requestTypeText}`)}</b> : null}
      {attendance.reasonId ? <b>{getAttendanceReasonName(attendance.reasonId)}</b> : null}
      {attendance.reasonId && true ? ', ' : null}
      {getDate()}, {attendance.requestStatusId ? <i>{t(`employee.requestStatus.${attendance.requestStatusId}`)}</i> : null}
    </>
  )
}

export default AttendanceItem
